import React, { useState, useRef } from 'react';
import { PDFDownloadLink} from '@react-pdf/renderer';
import PrintTimeing1 from './PrintTimeing1';
import { InputNumber } from "primereact/inputnumber";
import { Button } from 'primereact/button';
import { Link, Navigate, resolvePath } from "react-router-dom";
import { Col, Form, Row } from 'react-bootstrap';
import * as util from '../shared/commons';
import ShowVideo from '../shared/ShowVideo';

export default function  PrintTimeing(props){
    const [creating, setCreating] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(60);
    const [captionRowHeight, setCaptionRowHeight] = useState(40);
    const [dataRowHeight, setDataRowHeight] = useState(20);
    const [dataColWidth, setDataColWidth] = useState(150);
    const [dayColWidth, setDayColWidth] = useState(70);
    const [classColWidth, setClassColWidth] = useState(110);
    const [margin, setMargin] = useState(30);
    const [fontSize1, setFontSize1] = useState(8);
    const [fontSize2, setFontSize2] = useState(6);
    const [linkVisible, setLinkVisible] = useState(false);
    const [btnCreateVisible, setBtnCreateVisible] = useState(true);
    const [pdfFileIsReady, setPdfFileIsReady] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");

    const onInputChanged = function(e, name){
      if(name == "headerHeight") setHeaderHeight(e.value);
      if(name == "captionRowHeight") setCaptionRowHeight(e.value);
      if(name == "dataRowHeight") setDataRowHeight(e.value);
      if(name == "dataColWidth") setDataColWidth(e.value);
      if(name == "dayColWidth") setDayColWidth(e.value);
      if(name == "classColWidth") setClassColWidth(e.value);
      if(name == "margin") setMargin(e.value);
      if(name == "fontSize1") setFontSize1(e.value);
      if(name == "fontSize2") setFontSize2(e.value);
      setLinkVisible(false); 
    }
    const onComplete = function(state, msg){
      console.log("on complete msg>", msg);
      if(state){
        setPdfFileIsReady(true);
      }
      else{
        setBtnCreateVisible(true);
        setLinkVisible(false);
      }
    }
    return(
      (redirectUrl != "")
          ?
          <Navigate to={redirectUrl} replace={false}  />
      :
      <>
      <ShowVideo videoId="school_timing" top={65} md={6} />
      <div className="card" style={{width:"100%", maxWidth:"525px", borderBlockColor:"#414141",marginTop:"20px" }}>

        <div style={{padding:"20px"}}>
            <label onClick={()=>setRedirectUrl("/school/timing")} style={{cursor:"pointer", color:"#3e9aff"}}>
            <img src={require('../lib/images/back.png')} width={24} />
            برگشت به برنامه هفتگی
            </label>
        </div>
        <div>
          <table>
            <tr>
              <td style={{width:"180px", textAlign:'left'}}>
                ارتفاع عنوان برنامه:
              </td>
              <td style={{width:"2px"}}></td>
              <td style={{width:"150px", textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={headerHeight} onChange={(e) => onInputChanged(e, 'headerHeight')} useGrouping={false}  maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{width:"180px", textAlign:'left'}}>
                ارتفاع ردیف اول:
              </td>
              <td style={{width:"2px"}}></td>
              <td style={{width:"150px", textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={captionRowHeight} onChange={(e) => onInputChanged(e, 'captionRowHeight')} useGrouping={false}  maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
                ارتفاع ردیف ها:
              </td>
              <td></td>
              <td style={{textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={dataRowHeight} onChange={(e) => onInputChanged(e, 'dataRowHeight')} useGrouping={false}  maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
                پهنای هر زنگ:
              </td>
              <td></td>
              <td style={{textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={dataColWidth} onChange={(e) => onInputChanged(e, 'dataColWidth')} useGrouping={false}  maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
                پهنای نام روز:
              </td>
              <td></td>
              <td style={{textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={dayColWidth} onChange={(e) => onInputChanged(e, 'dayColWidth')} useGrouping={false}  maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
                پهنای نام کلاس:
              </td>
              <td></td>
              <td style={{textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={classColWidth} onChange={(e) => onInputChanged(e, 'classColWidth')} useGrouping={false}  maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
                حاشیه کاغذ:
              </td>
              <td></td>
              <td style={{textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={margin} onChange={(e) => onInputChanged(e, 'margin')} useGrouping={false}  maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
                اندازه فونت 1:
              </td>
              <td></td>
              <td style={{textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={fontSize1} onChange={(e) => onInputChanged(e, 'fontSize1')} useGrouping={false}  maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
                اندازه فونت 2:
              </td>
              <td></td>
              <td style={{textAlign:'right'}}>
                <InputNumber inputId="integeronly" value={fontSize2} onChange={(e) => onInputChanged(e, 'fontSize2')} useGrouping={false}  maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
              </td>
              <td></td>
            </tr>
            <tr><td colSpan={4}>&nbsp;</td></tr>
            {
              btnCreateVisible?
              <tr>
                <td colSpan={4}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label=" آماده کردن فایل " icon="pi pi-check" onClick={()=>{setPdfFileIsReady(false);setBtnCreateVisible(false); setLinkVisible(true);}} severity="success" iconPos="right" loading={creating} />
                  </div>
                </td>
              </tr>
              :
              <></>
            }
            <tr>
              <td  colSpan={4} style={{paddingTop:"10px"}}>
                  {
                    linkVisible?
                    <PDFDownloadLink  style={{textDecoration:"0px"}}
                      document={<PrintTimeing1 
                        headerHeight={headerHeight? (headerHeight==""? 60 : headerHeight) : 60} 
                        captionRowHeight={captionRowHeight? (captionRowHeight==""? 40 : captionRowHeight) : 40} 
                        dataRowHeight={dataRowHeight? (dataRowHeight==""? 20 : dataRowHeight) : 20} 
                        dataColWidth={dataColWidth? (dataColWidth==""? 150 : dataColWidth) : 150} 
                        dayColWidth={dayColWidth? (dayColWidth==""? 70 : dayColWidth) : 70} 
                        classColWidth={classColWidth? (classColWidth==""? 110 : classColWidth) : 110} 
                        margin={margin? (margin==""? 30 : margin) : 30}
                        fontSize1={fontSize1? (fontSize1==""? "8pt" : fontSize1+"pt") : "8pt"}
                        fontSize2={fontSize2? (fontSize2==""? "6pt" : fontSize2+"pt") : "6pt"}
                        fontSize3={fontSize1? (fontSize1==""? "12pt" : (fontSize1+4)+"pt") : "12pt"}
                        onComplete={(state, msg)=>{onComplete(state, msg)}}
                        />} fileName={"school_timing_"+util.generateRandomUString(10)+".pdf"}>
                          {
                            pdfFileIsReady?
                            <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label>
                            :
                            <>درحال آماده سازی فایل...</>
                          }
                      {
                        // ({ blob, url, loading, error }) =>
                        // loading ? 'درحال آماده سازی فایل...' : <><label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود برنامه هفتگی!</label></>
                      }
                    </PDFDownloadLink>
                    :
                    <></>
                  }

              </td>
            </tr>
            <tr><td colSpan={4}>&nbsp;</td></tr>
          </table>

        </div>
      </div>
      </>
    )
}
